var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-carousel',{attrs:{"height":"250","cycle":"","interval":"10000","show-arrows":false,"hide-delimiters":""}},_vm._l((_vm.images),function(image,i){return _c('v-carousel-item',{key:i,attrs:{"src":image,"reverse-transition":"fade-transition","transition":"fade-transition"}},[_vm._t("content")],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }